import { useCrud } from '@/hooks/useCrud'
import ContributorGroupService from './contributorGroup.service'
import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { createOptions } from '@/utils/arrayHelper'
import { API_RESOURCE } from '@/constants/api.constant'

const resource = 'contributorGroups'

//TODO: Test
export const useContributorGroup = () => {
  const service = new ContributorGroupService()
  const baseCrud = useCrud(API_RESOURCE.CONTRIBUTOR_GROUP, service)

  const useContributorGroupOptions = ({ status = 'active' }) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: status } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: status } }),
      placeholderData: keepPreviousData,
      select: (data) => createOptions(data?.data, 'name', 'type'),
    })
  }

  const useContributorGroupDefaultUser = (type) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: 'active' } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: 'active' } }),
      placeholderData: keepPreviousData,
      select: (result) => {
        if (!result || !result.data || !Array.isArray(result.data) || result.data.length === 0) {
          return
        }
        const selectGroupConfig = result.data.find((group) => group?.type === type)

        return selectGroupConfig?.defaultUser
      },
    })
  }

  return {
    //Base CRUD
    useFetchAllContributorGroups: baseCrud.useFetchAll,
    useFetchContributorGroup: baseCrud.useFetchOne,
    useCreateContributorGroup: baseCrud.useCreate,
    useUpdateContributorGroup: baseCrud.useUpdate,
    useRemoveContributorGroup: baseCrud.useRemove,

    //Extra
    useContributorGroupOptions,
    useContributorGroupDefaultUser,
  }
}
